import {Component, Input, OnInit} from '@angular/core';
import {HelpDialogComponent} from '../help-dialog/help-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MessageService} from '../../services/message.service';

const defaultTitle = 'Info';
const defaultText = 'There is currently no help available for this item.';

@Component({
  selector: 'app-help-icon-button',
  templateUrl: './help-icon-button.component.html',
  styleUrls: ['./help-icon-button.component.scss']
})
export class HelpIconButtonComponent implements OnInit {

  @Input() code?: string;

  constructor(private dialog: MatDialog, private readonly messageService: MessageService) { }

  ngOnInit(): void {
  }

  openInfoDialog(): void {
    if (this.code) {
      this.messageService.getDialogInfo(this.code).subscribe((data) => {
        if (data !== null) {
          this.dialog.open(HelpDialogComponent, {data: {title: data.comment, text: data.description}, maxWidth: 600});
        }
        else {
          this.dialog.open(HelpDialogComponent, {data: {title: defaultTitle, text: defaultText}, maxWidth: 600});
        }
      });
    }
  }

}
